import { Chapter, MaskedLines, Reveal } from "@/components/aklive/motion";

export const Manifesto = () => (
  <section className="bg-coal py-40 text-paper md:py-64" data-testid="manifesto-section">
    <div className="container-ak">
      <Chapter index="07" label="Manifesto" dark />
      <h2 className="max-w-5xl font-display text-4xl font-bold leading-[1.08] tracking-tight sm:text-5xl lg:text-6xl">
        <MaskedLines lines={["Good design shouldn't", "exist separately", "from the business."]} />
      </h2>
      <Reveal delay={0.5} className="mt-16 md:mt-28">
        <p className="font-display text-2xl font-bold tracking-tight text-ember sm:text-3xl lg:text-4xl">
          It should help move it forward.
        </p>
      </Reveal>
    </div>
  </section>
);
